import React, { useState } from 'react';
import { Modal, Box, IconButton, Typography, Stack, Paper, Avatar, TextField, Button, LinearProgress, } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';
import LeadService from '../../../core/services/leadsService';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: 'auto',
    height: 'auto',
    overflow: 'auto',
};

const validationSchema = yup.object({
    currentPassword: yup.string().required('Current password is required'),
    newPassword: yup
        .string()
        .min(6, 'Password must be at least 6 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('New password is required'),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
        .required('Please confirm your new password'),
});
const ICAUpdatePassword = ({openUpdatePassword,setOpenUpdatePassword,handleOpenUpdatePassword}) => {
    const [loading, setLoading] = useState(false);
    const handleClose = () => {
        setOpenUpdatePassword(false);
        formik.resetForm();
    };
    const formik = useFormik({
        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const { currentPassword, newPassword, confirmPassword } = values;
            try {
                setLoading(true);
                const res = await LeadService.updateIcaProfilePassword(String(currentPassword), String(newPassword), String(confirmPassword));
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    formik.resetForm();
                    setOpenUpdatePassword(false);
                }
            } catch (error) {
                toast.error(error.message); // Handle error
            } finally {
                setLoading(false); // Reset loading state
            }
        },
    });
    return (
        <div>
           
            <Modal open={openUpdatePassword} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <IconButton style={{ position: 'absolute', top: '3px', right: '20px' }} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>

                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ marginTop: '18px' }}>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            <Box position={'relative'}>
                                <Box >
                                    <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div>
                                            <Typography sx={{ fontSize: '32px', fontWeight: '700', mb: 5 }}>Update Password</Typography>
                                        </div>
                                    </Box>
                                    <form style={{ width: '500px' }} onSubmit={formik.handleSubmit}>
                                        <Stack spacing={2}>
                                            <TextField
                                                fullWidth
                                                id="currentPassword"
                                                name="currentPassword"
                                                label="Current Password"
                                                value={formik.values.currentPassword}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.currentPassword && Boolean(formik.errors.currentPassword)}
                                                helperText={formik.touched.currentPassword && formik.errors.currentPassword}
                                                onKeyDown={(event) => {
                                                    event.stopPropagation();
                                                }}
                                            />
                                            <TextField
                                                fullWidth
                                                id="newPassword"
                                                name="newPassword"
                                                label="New Password"
                                                value={formik.values.newPassword}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                                                helperText={formik.touched.newPassword && formik.errors.newPassword}
                                                onKeyDown={(event) => {
                                                    event.stopPropagation();
                                                }}
                                            />
                                            <TextField
                                                fullWidth
                                                id="confirmPassword"
                                                name="confirmPassword"
                                                label="Confirm Password"
                                                value={formik.values.confirmPassword}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                                onKeyDown={(event) => {
                                                    event.stopPropagation();
                                            }}
                                            />
                                            <Box>
                                                <Button
                                                    type="submit"
                                                    disabled={loading}
                                                    sx={{
                                                        bgcolor: 'rgb(25, 118, 210)',
                                                        borderBottomLeftRadius: '0px',
                                                        borderBottomRightRadius: '0px',
                                                        borderRadius: '10px',
                                                        textTransform: 'capitalize',
                                                    }}
                                                    variant="contained"
                                                    fullWidth
                                                >
                                                    Update Password
                                                </Button>
                                                <LinearProgress sx={{ visibility: loading ? '' : 'hidden' }} />
                                            </Box>
                                        </Stack>
                                    </form>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};
export default ICAUpdatePassword;
